import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/bookings/group/group-client.tsx");
